
import { configureStore } from '@reduxjs/toolkit';
import scheduleTaskListReducer from './scheduleTaskListStore';
import scheduleGroupReducer from "./scheduleGroup";
import scheduleLocationReducer from './schedulelocation';
import filterGroupReducer from "./filterstore";
import setFacilityTypeDetails from './faciltytypeSlice';
import configureStatusColorReducer from './configureStatusColor';
// import ServicefilterGroupReducer from "./ServiceRequestFilterStore"
import setPageRecordLimit from './paginationSizeStore';
import dateDataReducer from "./dateSlice";
import archivedStateReducer from './archiveState';
const store = configureStore({
    reducer: {
        scheduleTaskList: scheduleTaskListReducer,
        scheduleGroup: scheduleGroupReducer,
        scheduleLocation: scheduleLocationReducer,
        filterGroup: filterGroupReducer,
        facilityType: setFacilityTypeDetails,
        statusColorGroup: configureStatusColorReducer,
        // serviceGroupFilter: ServicefilterGroupReducer,
        rowRecordLimit: setPageRecordLimit,
        dateData:dateDataReducer,
        archivedState:archivedStateReducer
    },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export default store;
